export function isWeChat() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.includes('micromessenger');
  }
  
export function isSpider() {
const ua = window.navigator.userAgent.toLowerCase();
const spiders = [
    'googlebot', 'bingbot', 'yandexbot', 'duckduckbot', 'baiduspider',
    'slurp', 'sogou', 'exabot', 'facebot', 'ia_archiver'
];
return spiders.some(spider => ua.includes(spider));
}